<template>
  <div>
    <div class="main-wrapper">
      <sidebar-component classMenu="Rute"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <margin-estimasi-form
                v-if="isReady"
                title="Detail Margin Estimasi"
                submit-label="Submit"
                :value="form"
                :loading="isLoading"
                :errors="errors"
                mode="detail"
                @cancel="backForm"
              />
            </div>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import MarginEstimasiForm from "@/components/master/margin_estimasi/MarginEstimasiForm.vue";

export default {
  name: "MarginEstimasiDetail",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "margin-estimasi-form": MarginEstimasiForm,
  },
  data() {
    return {
      isLoading: false,
      isReady: false,
      errors: {},
      form: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      const baseURI =
        this.$settings.endPoint +
        "transport-order-margin-estimasi/detail/" +
        this.$route.params.id;

      this.isLoading = true;
      this.$http
        .get(baseURI)
        .then((response) => {
          this.isLoading = false;
          this.form = response.data?.datas || {};
          this.isReady = true;
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleHttpError(error);
        });
    },

    backForm() {
      this.$router.push("/master-margin-estimasi");
    },

    handleHttpError(error) {
      if (!error.response) {
        return;
      }

      if (error.response.status === 500) {
        this.$router.push("/server-error");
      } else if (error.response.status === 401) {
        this.$router.push("/authorized-error");
      } else {
        this.$router.push("/page-not-found");
      }
    },
  },
};
</script>
